<template>
  <fade-down-modal :show="showState">
    <div class="comModals" :style="{ 'width': modalWidth + 'px' }">
      <div class="header pr">
        <header-tag :title="title"></header-tag>
        <i class="pa f30 closeIcon cp" @click="showState = false">×</i>
      </div>
      <div class="body" style="">
        <slot></slot>
      </div>
      <div class="border-bottom"></div>
      <div class="bottom">
        <div class="wrong">
          <p v-text="wrongWord" ref="wrong"></p>
        </div>
        <div class="right">
          <a href="#" class="blue-btn" @click.prevent="confirm" v-show="confirmBtn" v-text="confirmTxt"></a>
          <a href="#" class="default-btn" @click.prevent="cancle" v-text="cancleTxt"></a>
        </div>
      </div>
    </div>
  </fade-down-modal>
</template>
<script>
// 头部tag内容
import HeaderTag from '_c/tagTitle/headerTag'
import FadeDownModal from '_c/modals/fadeDown'
export default {
  props: {
    modalWidth: {
      type: Number,
      default: 600
    },
    title: {
      type: String,
      default: ''
    },
    confirmTxt: {
      type: String,
      default: '确定'
    },
    cancleTxt: {
      type: String,
      default: '取消'
    },
    confirmBtn: {
      type: Boolean,
      default: true
    }
  },
  components: {
    HeaderTag,
    FadeDownModal
  },
  data () {
    return {
      showState: false,
      wrongWord: ''
    }
  },
  mounted () {
    // 监听键盘按键事件
    // let self = this;
    // this.$nextTick(function () {
    //   document.addEventListener('keyup', function (e) {
    //     //此处填写你的业务逻辑即可
    //     if (e.keyCode == 27)
    //     {
    //       self.showState = false;
    //     }
    //   })
    // })
  },
  methods: {
    show () {
      this.showState = true
    },
    hide () {
      this.showState = false
    },
    setWrong (str) {
      this.wrongWord = str
      this.$domFn.shake(this.$refs.wrong)
    },
    /* eslint-disable */
    clearWrong (str) {
      this.wrongWord = "";
    },
    confirm () {
      this.$emit("confirm");
    },
    cancle () {
      this.showState = false;
      this.$emit("cancel");
      this.wrongWord = "";
    }
  }
};
</script>
<style lang="scss" scoped>
@import "_style/_color.scss";

.comModals {
  color: $black-1;
  background: #fff;
  min-width: 1000px;
  margin: 0 auto;
  z-index: 99;
  max-height: 900px;
  overflow-y: auto;
}
.editorCon {
  .body{
    max-height:700px;overflow:auto;
  }
}
.header {
  height: 50px;
  line-height: 50px;
  text-align: left;
  padding-left: 30px;
  border-bottom: 1px solid #e5e5e5;
  background: #F8F8F8;
}

.border-bottom {
  width: 90%;
  margin: 0 auto;
  border-top: 1px solid #e5e5e5;
}

.bottom {
  overflow: hidden;
  text-align: right;
  padding-right: 30px;
  padding-left: 30px;
  height: 70px;

  // border-top: 1px solid #e5e5e5;
  a {
    margin-left: 10px;
  }

  .right {
    padding: 20px 0;
    float: right;
  }
}

.wrong {
  float: left;
  line-height: 70px;
  color: #ff3333;
  max-width: 200px;
  text-align: left;

  p {
    line-height: 14px;
    display: inline-block;
    vertical-align: middle;
  }
}

.closeIcon {
  right: 20px;
}
</style>
